import { render } from "./WorkComponent.vue?vue&type=template&id=22ef6976"
import script from "./WorkComponent.vue?vue&type=script&lang=js"
export * from "./WorkComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__